import React from "react";
import "./index.scss";

function Container({ children }) {
  return (
    <div className="container">
      {/*<div className="breadcrumbs">*/}
      {/*  You are here > Staff Member*/}
      {/*</div>*/}
      <div className="children">{children}</div>
    </div>
  );
}

export default Container;
